<template>
  <section class="post-section">
    <h3 class="post-section__title">Serviços adicionais</h3>
    <el-form :model="ruleForm" ref="ruleForm" label-position="top" class="post-form">
      <el-form-item v-show="false">
        <el-checkbox @change="change('warning', 'digital')" v-model="ruleForm.warning"
          >Aviso Recebimento (A.R.)</el-checkbox
        >
        <el-checkbox v-model="ruleForm.ownhand">Mãos Próprias (M.P.)</el-checkbox>
        <el-checkbox v-model="ruleForm.ap">
          Artigos Perigosos (A.P.)
          <ArtigosPerigososPopover />
        </el-checkbox>
      </el-form-item>
      <el-form-item v-show="false">
        <el-checkbox @change="change('digital', 'warning')" v-model="ruleForm.digital"
          >Aviso Recebimento Eletrônico (A.R-E)</el-checkbox
        >
      </el-form-item>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="12">
          <el-form-item :label="$t('telefone')">
            <el-input v-model="ruleForm.phone" v-mask="['(##) ####-####', '(##) #####-####']"></el-input>
            <el-checkbox v-model="ruleForm.whatsapp">Receber notificações no Whatsapp</el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item :label="$t('embalagem')" prop="package">
            <PackingList
              ref="package"
              v-model="ruleForm.package"
              v-on:selected="selected"
              :current="ruleForm.package"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="12">
          <el-form-item :label="$t('observacao')">
            <el-input type="textarea" :rows="2" maxlength="100" show-word-limit v-model="ruleForm.observation"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form-item :label="$t('aos-cuidados')">
            <el-input type="textarea" :rows="2" maxlength="57" v-model="ruleForm.care"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </section>
</template>
<script>
import PackingList from "@/xpost/views/register/packing/PackingList";
import ArtigosPerigososPopover from "@/components/ArtigosPerigososPopover";
export default {
  name: "PostServicesAditional",
  components: { PackingList, ArtigosPerigososPopover },
  data() {
    return {
      ruleForm: {
        warning: false,
        digital: false,
        ownhand: false,
        ap: false,
        phone: "",
        whatsapp: true,
        observation: "",
        care: "",
      },
    };
  },
  methods: {
    change(a, b) {
      const vm = this;
      if (vm.ruleForm[a]) vm.ruleForm[b] = false;
    },
    setup(form, data) {
      this.ruleForm.digital = form.digital;
      this.ruleForm.warning = form.digital ? false : form.warning;
      this.ruleForm.ownhand = form.ownhand;
      this.ruleForm.ap = form.ap;
      console.log("form", form, this.ruleForm);
    },
    selected() {},
  },
};
</script>
